import NotesComponent from './NotesComponent';

export default NotesComponent;
